import { Box, useMediaQuery, Drawer, styled, List } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { usePathname } from "next/navigation";
import {
  hoverSidebar,
  toggleMobileSidebar,
} from "@/store/customizer/CustomizerSlice";
import Scrollbar from "@/app/components/Scrollbar";
import Menuitems from "./MenuItems";
import NavItem from "./NavItem";

const Sidebar = () => {
  const pathname = usePathname();
  const pathDirect = pathname;
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const customizer = useSelector((state) => state.customizer);
  const dispatch = useDispatch();
  const theme = useTheme();

  const toggleWidth =
    customizer.isCollapse && !customizer.isSidebarHover
      ? customizer.MiniSidebarWidth
      : customizer.SidebarWidth;

  const hideMenu = lgUp
    ? customizer.isCollapse && !customizer.isSidebarHover
    : "";

  const onHoverEnter = () => {
    if (customizer.isCollapse) {
      dispatch(hoverSidebar(true));
    }
  };

  const onHoverLeave = () => {
    dispatch(hoverSidebar(false));
  };

  const ScrollbarNoIndicator = styled(Scrollbar)({
    "&::-webkit-scrollbar": {
      width: "0px !important",
      height: "0px !important",
      display: "none !important",
    },
    "& *::-webkit-scrollbar": {
      width: "0px !important",
      height: "0px !important",
      display: "none !important",
    },
    msOverflowStyle: "none !important",
    scrollbarWidth: "none !important",
    "& *": {
      msOverflowStyle: "none !important",
      scrollbarWidth: "none !important",
    },
  });

  const renderSidebarItems = () => (
    <Box sx={{ px: 3 }}>
      <List
        sx={{
          display: lgUp ? "flex" : "none",
          flexDirection: "column",
          overflowX: mdDown ? "auto" : "visible",
        }}
        className="sidebarNav"
      >
        {Menuitems.map((item) => (
          <NavItem
            item={item}
            key={item.id}
            aria-label={item.ariaLabel}
            pathDirect={pathDirect}
            hideMenu={hideMenu}
            onClick={() => dispatch(toggleMobileSidebar())}
          />
        ))}
      </List>
    </Box>
  );

  return (
    <>
      {!lgDown ? (
        <Box
          sx={{
            zIndex: 1,
            width: toggleWidth,
            flexShrink: 1,
            ...(customizer.isCollapse && {
              position: "absolute",
            }),
          }}
        >
          <Drawer
            anchor="left"
            open
            onMouseEnter={onHoverEnter}
            onMouseLeave={onHoverLeave}
            variant="permanent"
            slotProps={{
              paper: {
                sx: {
                  transition: theme.transitions.create("width", {
                    duration: theme.transitions.duration.shortest,
                  }),
                  width: toggleWidth,
                  boxSizing: "border-box",
                  borderRight: "none",
                  backgroundColor: theme.palette.background.default,
                  zIndex: 0,
                },
              },
            }}
          >
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                marginTop: customizer.TopbarHeight + 40 + "px",
              }}
            >
              <ScrollbarNoIndicator
                sx={{ flexGrow: 1, width: "100%" }}
                className="hide-scrollbar"
              >
                {renderSidebarItems()}
              </ScrollbarNoIndicator>
            </Box>
          </Drawer>
        </Box>
      ) : null}
    </>
  );
};

export default Sidebar;
